import Controller from "../Engine/Controller";
import Engine from "../Engine/Engine";
import cfJS from "../Engine/cfJS";

class Input extends Controller {
    constructor(dom, options) {
        super(dom, "Input");

        this.type = this._returnDomType(options);

        this.options = options ? options : {};

        this._configByType();
    }

    _returnDomType(options) {
        /*if (options["type"])
            return options["type"];*/

        return this.domNode.getAttribute("type") ? this.domNode.getAttribute("type") : "text"
    }
    /*
    * set some specials events/functions
    */
    _configByType() {
        switch (this.type) {
            case "file":
                this.value = null;

                this._appendFileTypeEvents();

                if (this.options["previewImgDomId"])
                    this._connectFilesPreviewListeners();

                if (this.options["simpleFile"])
                    this._connectSimpleFileButton();
            break;
        }
    }

    _connectSimpleFileButton() {
        let domNode = this.domNode;

        cfJS.addListener( cfJS.querySelector(domNode.parentNode,"button"), "click", function (e) {
            domNode.click();

            e.preventDefault();
            return false;
        });

        cfJS.addListener(domNode, "change", function () {
            if (this.files) {
                let files = this.files[0],
                    reader = new FileReader();

                reader.onload = function (event) {
                    cfJS.querySelector(domNode.parentNode,"span").innerText = files.name;
                };

                reader.readAsDataURL(files);
            }
        });
    }

    _connectFilesPreviewListeners() {
        let domNode = this.domNode,
            that = this;

        cfJS.addListener(domNode, "change", function () {
            if (this.files) {
                let files = this.files[0],
                    reader = new FileReader();

                let previewDom = cfJS.byId(that.options["previewImgDomId"]);

                reader.onload = function (event) {
                    cfJS.attr(previewDom, "src", event.target.result);
                };

                reader.readAsDataURL(files);
            }
        });
    }

    /*
    * append listeners and events to file type input
    */
    _appendFileTypeEvents() {
        let domNode = this.domNode,
            that = this;

        cfJS.addListener(domNode, "change", function () {
            if (this.files) {
                that.value = [];

                if (domNode.getAttribute("multiple") === "true" && this.files.length > 1) {
                    for (var i = 0; i < this.files.length; i++) {
                        that.value[that.value.length] = this.files[i];
                    }
                }
                else
                    that.value = this.files[0];
            }
        });
    }

    /*
    * set pre set value
    * */
    setValue(data) {
        this.value = data;
        return data;
    }

    /*
    * get setted value from input
    */
    getValue() {
        return this.value;
    }
}

window.Input = Input;

export default Input;